/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-google-round-inline-62c7a85e--sprite",
  "use": "social-google-round-inline-62c7a85e--sprite-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"social-google-round-inline-62c7a85e--sprite\">\n  <g transform=\"translate(-887 -948)\">\n    <g transform=\"translate(3.517 -62)\">\n      <path d=\"M18.422,7a14.312,14.312,0,0,0-.289-2.6H6V9.456h6.933a5.949,5.949,0,0,1-2.6,3.9v3.322h4.333A13.058,13.058,0,0,0,18.422,7Z\" transform=\"translate(890.483 1016.289)\" fill=\"#4285f4\" fill-rule=\"evenodd\" />\n      <path d=\"M9.556,18.2a12.526,12.526,0,0,0,8.667-3.178l-4.333-3.178a8.089,8.089,0,0,1-4.333,1.3A7.772,7.772,0,0,1,2.333,7.8H-2v3.178A12.706,12.706,0,0,0,9.556,18.2Z\" transform=\"translate(886.928 1017.8)\" fill=\"#34a853\" fill-rule=\"evenodd\" />\n      <path d=\"M2.778,10.233a6.747,6.747,0,0,1-.433-2.456,6.747,6.747,0,0,1,.433-2.456V2H-1.556A13.15,13.15,0,0,0-3,7.778a11.446,11.446,0,0,0,1.444,5.778l4.333-3.322Z\" transform=\"translate(886.483 1015.222)\" fill=\"#fbbc05\" fill-rule=\"evenodd\" />\n      <path d=\"M9.556,2.2a7.406,7.406,0,0,1,4.911,1.878L18.222.322A12.625,12.625,0,0,0,9.556-3,12.706,12.706,0,0,0-2,4.222L2.333,7.544A7.772,7.772,0,0,1,9.556,2.2Z\" transform=\"translate(886.928 1013)\" fill=\"#eb4335\" fill-rule=\"evenodd\" />\n    </g>\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
